import React, { forwardRef } from "react"
import cs from "classnames"
import { useEventWrapper } from "../useEventWrapper"
import Wrapper from "../Wrapper"
import * as StyleSheet from "../styles"

const Select = forwardRef(({
  name,
  label = "",
  value,
  defaultValue,
  options = [],
  onChange = () => null,
  disabled = false,
  className,
  theme = "",
  placeholder = "",
  error,
  ...rest
}, ref) => {
  const styleSheet = StyleSheet[theme]?.(disabled, error) || StyleSheet["profile"](disabled, error)
  const _onChange = useEventWrapper(onChange)

  return (
    <Wrapper label={label} className={className} name={`select-${name}`} styleSheet={styleSheet} error={error}>
      <select
        ref={ref}
        aria-label={`select ${label}`}
        className={cs(styleSheet.input)}
        value={value}
        onChange={_onChange}
        disabled={disabled}
        {...rest}
      >
        {placeholder && (
          <option value={defaultValue} className="hidden" defaultValue>
            {placeholder}
          </option>
        )}
        {options && Array.isArray(options)
          ? options.map((option, index) => {
              const optionKey = `${String(option?.value ?? option)}-${index}`
              return typeof option === "object" ? (
                <option key={optionKey} value={option?.value}>
                  {option?.text}
                </option>
              ) : (
                <option key={optionKey} value={option}>
                  {option}
                </option>
              )
            })
          : Object.entries(options).map(([key, val]) => (
              <option key={key} value={key}>
                {typeof val === "object" ? val.text || val.name : val}
              </option>
            ))}
      </select>
    </Wrapper>
  )
})
Select.displayName = "Select"

export default Select
